import React from 'react';
import getStyleObject from './getStyleObject';
import { NODES } from '../../constants';

const asPlainObject = (obj) => {
  if (obj && typeof obj.toJS === 'function') {
    return obj.toJS();
  } else {
    return obj;
  }
};

const renderNode = (props, editor, next) => {
  const { node, attributes, children } = props;
  const { data } = node;

  switch (node.type) {
    case NODES.PARAGRAPH:
      return <p {...attributes}>{children}</p>;
    case NODES.PARAGRAPH_LEFT:
      return (
        <p {...attributes} style={{ textAlign: 'left' }}>
          {children}
        </p>
      );
    case NODES.PARAGRAPH_CENTER:
      return (
        <p {...attributes} style={{ textAlign: 'center' }}>
          {children}
        </p>
      );
    case NODES.PARAGRAPH_RIGHT:
      return (
        <p {...attributes} style={{ textAlign: 'right' }}>
          {children}
        </p>
      );
    case NODES.PARAGRAPH_JUSTIFY:
      return (
        <p {...attributes} style={{ textAlign: 'justify' }}>
          {children}
        </p>
      );
    case NODES.HEADING_2:
      return (
        <h2 {...attributes}>
          {children}
        </h2>
      );
    case NODES.HEADING_3:
      return (
        <h3 {...attributes}>
          {children}
        </h3>
      );
    case NODES.HEADING_4:
      return (
        <h4 {...attributes}>
          {children}
        </h4>
      );
    case NODES.HEADING_5:
      return (
        <h5 {...attributes}>
          {children}
        </h5>
      );
    case NODES.HEADING_6:
      return (
        <h6 {...attributes}>
          {children}
        </h6>
      );
    case NODES.LINK:
      return (
        <a
          {...attributes}
          target={data.get('target')}
          href={data.get('href')}
          data-event-name={data.get('eventName')}>
          {children}
        </a>
      );
    case NODES.ORDERED_LIST:
      return <ol {...attributes}>{children}</ol>;
    case NODES.UNORDERED_LIST:
      return <ul {...attributes}>{children}</ul>;
    case NODES.LIST_ITEM:
      return <li {...attributes}>{children}</li>;
    case NODES.IMAGE: {
      const style = getStyleObject(data.get('style'));
      return (
        <img
          {...attributes}
          src={data.get('src')}
          alt={data.get('alt')}
          style={asPlainObject(style)}
        />
      );
    }
    case NODES.SNIPPET:
      return (
        <div
          className="snippet_block"
          {...attributes}
          dangerouslySetInnerHTML={{ __html: data.get('snippetName') }}
        />
      );
    case NODES.TRANSLATION:
      return (
        <span
          {...attributes}
          className="translation_key"
          dangerouslySetInnerHTML={{ __html: data.get('translationKey') }}
        />
      );
    case NODES.VIDEO:
      return (
        <div
          {...attributes}
          className="embed_wrapper"
          dangerouslySetInnerHTML={{ __html: data.get('embedText') }}
        />
      );
    case NODES.DIV:
      return <div {...attributes}>{children}</div>;
    case NODES.SPAN:
      return <span {...attributes}>{children}</span>;
    case NODES.SNIPPET_BUTTON:
      return (
        <a className="snippet_button" href={data.get('href')} data-event-name={data.get('eventName')}>
          {data.get('label')}
        </a>
      );
    default:
      return next();
  }
};

export default  renderNode;
